import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PbTableToolbarProps from "./PbTableToolbarProps.type";

import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";

import SearchInput from "../../../simple/SearchInput/SearchInput";
import React from "react";
import styled from "@emotion/styled";

const ToolBarContent = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
});

const PbTableToolbar = (props: PbTableToolbarProps): JSX.Element => {
  const { onSearch, onSearchChange, title, showSearch } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <ToolBarContent>
        <Typography
          sx={{ flex: "1 1 100%", marginBottom: "10px" }}
          variant="h5"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>

        {showSearch ? (
          <SearchInput
            onSearch={onSearch}
            onSearchChange={onSearchChange}
            placeHolder={"search"}
            key={`search-${title}`}
          />
        ) : null}
      </ToolBarContent>
      {/*<Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>*/}
    </Toolbar>
  );
};

export default PbTableToolbar;
